var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeFlower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.95243e-07 19.4982C6.34539e-07 29.5201 19.9998 19.4982 19.9998 19.4982C19.9998 19.4982 -2.44053e-07 9.47619 1.95243e-07 19.4982Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 19.4982C40 29.5201 20.0002 19.4982 20.0002 19.4982C20.0002 19.4982 40 9.47619 40 19.4982Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99859 36.773C18.7021 41.784 19.9985 19.5008 19.9985 19.5008C19.9985 19.5008 1.2951 31.762 9.99859 36.773Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0005 2.2271C38.704 7.23809 20.0006 19.4993 20.0006 19.4993C20.0006 19.4993 21.2971 -2.78388 30.0005 2.2271Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.999 36.773C21.2955 41.784 19.9991 19.5008 19.9991 19.5008C19.9991 19.5008 38.7025 31.762 29.999 36.773Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 2.2271C1.29744 7.23809 20.0008 19.4993 20.0008 19.4993C20.0008 19.4993 18.7044 -2.78388 10.0009 2.2271Z",
    fill: "#E55733"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeFlower);
export default __webpack_public_path__ + "static/media/orange-flower.97cc9dd5cce5fa29596cd5b928ffbfff.svg";
export { ForwardRef as ReactComponent };